import { useEffect, useState } from 'react';
import { useLocalTranslation } from '@/hooks/useLocalTranslation';
import CheckBox from '@/components/profile/checkBox'
import { listOfSections } from "@/pages/profile/sections/idVerification/constants"
import ImageHandler from '@/components/common/imageHandler/imageHandler'
import ImageEditer from '@/components/common/imageHandler/imageEditer'
import UploadImage from "@/assets/icons/upload.png"
import '@/pages/profile/sections/common.css'

export default function LegalPhoto(props: any) {
    const { common, profile } = useLocalTranslation();
    const [openFilePopup, setOpenFilePopup] = useState(false)
    const [image, setImage] = useState("")

    useEffect(() => {
        if (props.value) {
            setImage(props.value)
        }
    }, [props.value])


    const initFilePopup = () => {
        setOpenFilePopup(true)
        setTimeout(() => {
            setOpenFilePopup(false)
        }, 100)
    }

    const imageSelected = (imageDataURI: any) => {
        setImage(imageDataURI)
        setImgToParentCom(imageDataURI)
    }

    const setImgToParentCom = (imageDataURI: any) => {
        const eventObj = {
            target: {
                value: imageDataURI
            }
        }
        props.handleInputChange(eventObj, listOfSections.legalPhoto)
    }

    return (
        <div className='profileSectionOfSectionCommonMainCon'>

            <p className='commonH5'>
                {profile.fields.legalPhoto}
                <span className='text-[#FF2828]'>*</span>
            </p>

            <p className='commonH7'>
                {profile.placeHolders.uploadYourLegalPhoto}
            </p>

            {props.errMsg !== "" &&
                <p className='commonErr1'>{props.errMsg}</p>
            }

            {image ? (
                <div className='proofImgCon'>
                    <ImageEditer
                        initFilePopup={initFilePopup}
                        ogImage={image}
                        setImgToParentCom={setImgToParentCom}
                    // height={200}
                    // width={330}
                    />
                </div>
            ) : (
                <div className='imagePlaceholder'>
                    <img
                        className='w-[42px]'
                        src={UploadImage} alt='UploadImage' />
                    <p className='p1'>{common.statusText.tapOrClickHereToUploadYourDocument}</p>
                    <button
                        onClick={initFilePopup}
                        className='b1'>
                        {common.statusText.browseFiles}
                    </button>
                </div>
            )}

            <ImageHandler
                openFilePopup={openFilePopup}
                imageSelected={imageSelected}
            />

            <div className='commonBtnCon1'>
                {image &&
                    <div className='w-[100%] text-left'>
                        <CheckBox
                            id="identityAcknowledged_id"
                            text={profile.identityVerificationSection.notes.n11}
                            checked={props.identityAcknowledged}
                            onChange={(e: any) => props.handleOnCheckBoxChanged(e, "identityAcknowledged")}
                            showAsterisk={true}
                        />

                        <button
                            disabled={props.isSubmitBtnLoading}
                            style={{
                                cursor: props.isSubmitBtnLoading ? 'not-allowed' : 'pointer',
                                backgroundColor: props.isSubmitBtnLoading ? '#9f9f9f' : '#1573FE'
                            }}
                            onClick={() => props.handleSubmit(listOfSections.legalPhoto)}
                            className='w-[100%] text-white rounded-[5px] py-[8px] text-[14px] font-medium'>
                            {common.statusText.saveAndContinueBtn}
                        </button>
                    </div>
                }
            </div>
        </div>
    );
}
